import React from 'react';
import { IconProps } from './types';

const ArrowTop: React.FC<IconProps> = ({
  className,
  size = 32,
  color = '#181B32',
  ignoreColor,
}) => (
  <svg
    className={className}
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    width={size * 1.5625}
    height={size}
    viewBox="0 0 50 32"
  >
    <path
      fill={!ignoreColor ? color : undefined}
      d="M1.9 20.2l18.25-18.15c1.3-1.35 3.15-2.050 4.85-2.050 1.85 0 3.5 0.7 4.9 2.050l18.2 18.3c2.65 2.75 2.65 7 0 9.65v0c-2.75 2.65-7 2.65-9.65 0l-13.45-13.45-13.5 13.45c-2.75 2.65-6.95 2.65-9.6 0v0c-2.55-2.65-2.55-7.050 0-9.8z"
    />
  </svg>
);

export default ArrowTop;
